
import React from "react";

interface DataLoaderProps {
  isLoading: boolean;
  error: string | null;
  isEmpty: boolean;
  emptyMessage?: string;
  children: React.ReactNode;
}

export const DataLoader: React.FC<DataLoaderProps> = ({
  isLoading,
  error,
  isEmpty,
  emptyMessage = "Aucune donnée trouvée",
  children,
}) => {
  if (isLoading) {
    return <p className="text-center py-8 text-muted-foreground">Chargement des données...</p>;
  }

  if (error) {
    return <p className="text-center py-8 text-red-500">{error}</p>;
  }

  if (isEmpty) {
    return <p className="text-center py-8 text-muted-foreground">{emptyMessage}</p>;
  }

  return <>{children}</>;
};
